import { theme } from '@qr-front/ui'
import { getVersionForClone } from '@qr-front/ui/utils'
import { atom } from 'jotai'

import {
	primaryColorAtom,
	secondaryColorAtom,
} from '@/content-from-sections/client'

import { isDemoModeAtom } from '../../../generatorState'

export const BUSINESS_PAGE_DEMO_PRIMARY_COLOR = getVersionForClone({
	base: theme.colors.brown,
	clone1: '#D97BC8',
})

export const businessPagePrimaryColorAtom = atom((get) =>
	get(isDemoModeAtom)
		? BUSINESS_PAGE_DEMO_PRIMARY_COLOR
		: get(primaryColorAtom),
)

export const businessPageSecondaryColorAtom = atom((get) =>
	get(isDemoModeAtom) ? 'black' : get(secondaryColorAtom),
)
